import { useState } from 'react';

import {
  Typography,
  Stack,
  Box,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
} from '@mui/material';
import styles from './IngredientsCard.module.scss';

export default function IngredientsCard({ item }) {
  const [showContent, setShowContent] = useState(false);
  const learnMoreHandle = () => {
    setShowContent(!showContent);
  };
  return (
    <div className={styles.imgCardContainer}>
      <Card className={styles.imgMainCard} onClick={learnMoreHandle}>
        <CardActionArea
          disableRipple
          className={styles.cardContentArea}
          sx={{
            '& .MuiCardActionArea-focusHighlight:hover': {
              opacity: 0,
            },
          }}
        >
          <Box
            className={`${styles.flipContentMain} ${
              showContent ? styles.cardBtnFadeOut : styles.cardBtnFadeIn
            }`}
          >
            {!showContent ? (
              <CardMedia
                component="img"
                image={item.image}
                alt=""
                className={styles.cardMedia}
              />
            ) : (
              <Stack className={styles.flipContentTextArea}>
                <Typography variant="h5" color="primary.black">
                  {item.qus}
                </Typography>
                <Typography
                  variant="p1"
                  component="div"
                  color="primary.black"
                  className={styles.ingredientDesc}
                  dangerouslySetInnerHTML={{ __html: item.content }}
                ></Typography>
                <Typography variant="h5" color="primary.black">
                  {item.volume} <br />
                  <Typography
                    variant="p1"
                    color="primary.black"
                    component="span"
                  >
                    Per Dose
                  </Typography>
                </Typography>
              </Stack>
            )}
          </Box>
          <CardContent sx={{}} className={styles.cardConentMainArea}>
            <Typography
              variant="h3"
              color="primary.main"
              className={styles.cardItemName}
            >
              {item.name}
            </Typography>
            <div
              className={styles.cardBtn}
              onClick={learnMoreHandle}
              variant="outlined"
            >
              <Typography
                variant="h5"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: '5px',
                }}
              >
                Learn More{' '}
                <Typography
                  component="span"
                  variant="h5"
                  className={
                    showContent ? styles.cardBtnFadeOut : styles.cardBtnFadeIn
                  }
                >
                  {' '}
                  {!showContent ? (
                    <Box>+</Box>
                  ) : (
                    <Box sx={{ transform: 'scale(1.5)', marginLeft: '2px' }}>
                      -
                    </Box>
                  )}
                </Typography>
              </Typography>
            </div>
          </CardContent>
        </CardActionArea>
      </Card>
    </div>
  );
}
